var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useSyncedRef } from "../../../../../../misc/SyncedRef";
import { EventEmitter, sleep } from "nate-react-api-helpers";
export function useMemoryTableFetcher2(value, onChangeFx) { const fs = useMemoryTableFetcher(value, onChangeFx); const onChangeRef = useRef((t) => __awaiter(this, void 0, void 0, function* () { return t; })); onChangeRef.current = (v) => __awaiter(this, void 0, void 0, function* () { let remove = false; let update = value.map(h => { if (h.id === v.id) {
    if ("archived" in v && v.archived) {
        remove = true;
    }
    return Object.assign({}, v, { updatedAt: new Date().toISOString() });
} return h; }); if (remove) {
    update = update.filter(h => h.id !== v.id);
} if (!v.id || v.id <= 0) {
    v = Object.assign({}, v, { id: Date.now(), updatedAt: new Date().toISOString() });
    update.push(v);
} fs.onChange(update); return v; }); return { onChange: v => onChangeRef.current(v), fetch: fs.fetch }; }
export function useMemoryTableFetcher(value, onChangeFx) {
    const waitForChangeRef = useRef();
    const valueRef = useSyncedRef(value);
    const valueChanged = useMemo(() => new EventEmitter(), []);
    useEffect(() => { valueChanged.emit(value); }, [value, valueChanged]);
    const fetch = useCallback(() => __awaiter(this, void 0, void 0, function* () { if (waitForChangeRef.current) {
        yield waitForChangeRef.current;
    } return valueRef.current; }), [valueRef]);
    const onChangeRef = useSyncedRef(onChangeFx);
    const onChange = useCallback(v => {
        waitForChangeRef.current = Promise.race([waitForChange(valueChanged), sleep(2000) // timeout
        ]);
        return onChangeRef.current(v);
    }, [onChangeRef, valueChanged]);
    return { fetch, onChange };
}
function waitForChange(e) { return new Promise((resolve, reject) => { try {
    const sub = e.subscribe(s => { resolve(); sub.cancel(); });
}
catch (e) {
    reject(e);
} }); }
